import { readBase64 } from '../helpers';

export async function mapFileUpload(file: File): Promise<ArrayBuffer> {
  const base64 = await readBase64(file);
  return base64;
}
